module.exports = __webpack_public_path__ + "media/images/athlete-2x-1f81ee765a5667818165e637cb505703.png";